// What the dynamic module's search box reads.
//
// The module's CONFIG columns are the searchable set: `columns` is already resolved to the keys the
// rows carry (FK _Display siblings, _drv_* derived values) with visible:false and hidden entry-mode
// fields removed. Searching exactly those means a hit always has a visible cause — the old predicate
// matched every property of the row, so raw FK integers, ids and stringified booleans produced hits
// nobody could see. Hiding a column in Modify View deliberately does NOT change the set: results
// should not shift because someone rearranged their view, and every column keeps a stable field:
// prefix.
//
// The list panel's primary/secondary line fields are added when the config does not already list
// them, since those are what list view shows.

const humanize = (key) => String(key)
  .replace(/_Display$/, '')
  .replace(/_/g, ' ')
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/\b\w/g, c => c.toUpperCase());

/**
 * @param columns     resolved module columns [{ key, label }]
 * @param listFields  [primaryField, secondaryField] keys from the list panel config
 * @param sampleRow   any row, used only when the module has no configured columns at all
 * @returns {{ searchFields: string[], labels: {key: string, label: string}[] }}
 */
export const buildDynamicSearchFields = (columns, listFields = [], sampleRow = null) => {
  const labels = [];
  const seen = new Set();
  const add = (key, label) => {
    if (!key || key === 'id' || seen.has(key)) return;
    seen.add(key);
    labels.push({ key, label: label || humanize(key) });
  };

  (columns || []).forEach(c => add(c.key, c.label));
  (listFields || []).forEach(k => add(k));

  // No config: without a fallback applySearch would search nothing and every query would match
  // everything. String-valued keys only, so ids and booleans stay out as they do with a config.
  if (!labels.length && sampleRow) {
    Object.keys(sampleRow)
      .filter(k => typeof sampleRow[k] === 'string')
      .forEach(k => add(k));
  }

  return { searchFields: labels.map(l => l.key), labels };
};
